import { render, staticRenderFns } from "./QuickRegistration.vue?vue&type=template&id=1f32b0db"
import script from "./QuickRegistration.vue?vue&type=script&lang=js"
export * from "./QuickRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports